import { PureComponent as t } from "react";
import e from "ms";
var o = function (t, e, o) {
    return (t > 9 ? t : "0" + t) + ":" + (e > 9 ? e : "0" + e) + ":" + (o > 9 ? o : "0" + o);
  },
  n = function (t) {
    function n(e) {
      t.call(this, e);
      var n = e.hours,
        s = e.minutes,
        r = e.seconds,
        i = o(n, s, r);
      this.intervalId = setInterval(function () {}, Number.MAX_VALUE), this.state = {
        formatted: i,
        stateHours: n,
        stateMinutes: s,
        stateSeconds: r
      };
    }
    return t && (n.__proto__ = t), (n.prototype = Object.create(t && t.prototype)).constructor = n, n.prototype.componentWillReceiveProps = function () {
      this.intervalId = setInterval(function () {}, Number.MAX_VALUE), this.setState({
        stateHours: 0,
        stateMinutes: 0,
        stateSeconds: 0
      });
    }, n.prototype.componentDidMount = function () {
      this.props.autoStart && this.timer();
    }, n.prototype.componentWillUnmount = function () {
      this.stopToCount();
    }, n.prototype.stopToCount = function () {
      clearInterval(this.intervalId);
    }, n.prototype.counter = function () {
      var t = this,
        e = this.props,
        n = e.limit,
        s = e.withLoop,
        r = e.onCallback,
        i = e.onChange,
        a = this.state,
        u = a.stateHours,
        c = a.stateMinutes,
        p = a.stateSeconds;
      this.setState(function (t) {
        return {
          stateSeconds: t.stateSeconds + 1
        };
      }), p >= 59 && (this.setState(function (t) {
        return {
          stateSeconds: 0,
          stateMinutes: t.stateMinutes + 1
        };
      }), c >= 59 && this.setState(function (t) {
        return {
          stateMinutes: 0,
          stateHours: t.stateHours + 1
        };
      }));
      var h = o(u, c, p);
      this.setState({
        formatted: h
      }), i({
        hours: u,
        minutes: c,
        seconds: p
      }), n === h && setTimeout(function () {
        t.stopToCount(), s && t.timer(), r();
      }, 0);
    }, n.prototype.timer = function () {
      var t = this;
      this.counter();
      var o = setInterval(function () {
        t.counter();
      }, e("1s"));
      this.intervalId = o;
    }, n.prototype.render = function () {
      var t = this.props,
        e = t.children,
        o = t.render,
        n = this.state,
        s = n.formatted,
        r = n.stateHours,
        i = n.stateMinutes,
        a = n.stateSeconds;
      return e ? e({
        formatted: s,
        hours: r,
        minutes: i,
        seconds: a
      }) : o ? o({
        formatted: s,
        hours: r,
        minutes: i,
        seconds: a
      }) : (console.error("Component ReactStopWatch:", "no children or render prop are present"), null);
    }, n;
  }(t);
n.displayName = "ReactStopWatch", n.defaultProps = {
  autoStart: !0,
  withLoop: !1,
  onCallback: function () {},
  onChange: function () {}
};
export default n;